(function () {
  'use strict';

  const form = document.querySelector('[data-edesign-form]');
  if (!form) return;

  const root = document.querySelector('[data-edesign-root]');
  const endpoint = root ? root.dataset.endpoint : 'https://n8n.tnmseo.com/webhook/sophi';
  const status = form.querySelector('[data-edesign-status]');

  function setStatus(message) {
    if (status) status.textContent = message || '';
  }

  function fileToDataUrl(file) {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = () => resolve(String(reader.result || ''));
      reader.onerror = () => resolve('');
      reader.readAsDataURL(file);
    });
  }

  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    const button = form.querySelector('button[type="submit"]');
    const data = new FormData(form);
    const photos = await Promise.all(Array.from(form.querySelector('input[type="file"]').files || []).slice(0, 8).map(fileToDataUrl));
    const intake = {
      customer_id: data.get('customer_id') || '',
      name: data.get('name') || '',
      email: data.get('email') || '',
      phone: data.get('phone') || '',
      project_description: data.get('project_description') || '',
      room_types_dimensions: data.get('room_types_dimensions') || '',
      budget_range: data.get('budget_range') || '',
      timeline: data.get('timeline') || '',
      style_preferences: data.get('style_preferences') || '',
      photos: photos.filter(Boolean)
    };
    setStatus('Creating your eDesign deposit link');
    if (button) button.disabled = true;
    try {
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          intent: 'edesign_intake',
          session_id: window.localStorage.getItem('sophi_session_id') || 'edesign-page',
          customer_id: intake.customer_id,
          customer_email: intake.email,
          intake
        })
      });
      if (!response.ok) throw new Error('Intake failed');
      const payload = await response.json();
      setStatus('Your request is in. Opening your secure deposit checkout.');
      if (payload.invoice_url) {
        window.location.href = payload.invoice_url;
      }
    } catch (error) {
      setStatus('We could not submit the request just now. Please try again in a moment.');
      if (button) button.disabled = false;
    }
  });
})();
